<template>
  <div
    class="w-full flex gap-16 pr-40"
    :data-testid="['cartItem', productName].join('_')"
  >
    <div class="flex flex-row">
      <div class="w-32 me-16 flex items-start justify-end">
        <NuxtImg
          v-if="imgSrc"
          :src="imgSrc"
          alt=""
          class="min-w-32 w-full"
          loading="lazy"
          :provider="imgSrc.includes('cloudfront') ? 'cloudfront' : undefined"
        />
        <NuxtImg
          v-else
          src="/images/product_related/product_placeholder.svg"
          alt=""
          class="min-w-32 w-full"
          width="32"
          loading="lazy"
          provider="cloudfront"
        />
      </div>
      <div class="flex flex-col">
        <p class="heading-xxs">{{ productName }}</p>
        <div class="flex gap-6 body-md">
          <span v-for="(info, index) in itemInfo" :key="index">
            {{ info }}
          </span>
        </div>
        <p v-if="itemInfoSecondary" class="italic">
          {{ itemInfoSecondary }}
        </p>
        <div class="heading-xxs">
          <span v-if="priceString">{{ priceString }} </span>
          <span v-if="discountValidityInMonths && regPriceString.length > 0">
            <span>
              i
              {{ discountValidityInMonths.TholboxDiscountValidityInMonths }}
              mån
              <span v-if="regPriceString.length > 0">
                därefter
                {{ regPriceString }}
                <span
                  v-if="
                    bindPeriodTime &&
                    bindPeriodTime -
                      discountValidityInMonths.TholboxDiscountValidityInMonths >
                      0
                  "
                  class="body-md"
                >
                  i
                  {{
                    bindPeriodTime -
                    discountValidityInMonths.TholboxDiscountValidityInMonths
                  }}
                  mån
                </span>
              </span>
            </span>
          </span>
          <span v-else>
            <span v-if="bindPeriodTime" class="body-md">
              i {{ bindPeriodTime }} mån</span
            >
            <span
              v-if="downPayTime > 1 && !priceString.startsWith('0 kr')"
              class="body-md"
            >
              i {{ downPayTime }} mån</span
            >
          </span>
        </div>

        <div v-for="(appliedDiscount, index) in appliedDiscounts" :key="index">
          <p
            v-if="
              appliedDiscount.DiscountPercentage == 100 ||
              appliedDiscount.DiscountAmount.toString() == priceString
            "
            class="text-text-success text-20-24 font-xtrabold"
          >
            Produkt på köpet
          </p>

          <p
            v-else-if="
              appliedDiscount.CouponCode &&
              appliedDiscount.DiscountPercentage != 0 &&
              appliedDiscount.UsePercentage
            "
            class="text-text-success text-20-24 font-xtrabold"
          >
            {{ appliedDiscount.DiscountPercentage }} % rabatt med koden
            {{ appliedDiscount.CouponCode }}
          </p>
          <p
            v-else-if="
              appliedDiscount.CouponCode && appliedDiscount.DiscountAmount != 0
            "
            class="text-text-success text-20-24 font-xtrabold"
          >
            {{ appliedDiscount.DiscountAmount }} kr rabatt med koden
            {{ appliedDiscount.CouponCode }}
          </p>
        </div>
      </div>
    </div>
    <IconButton
      v-if="removeSpecificItem"
      :aria-label="`Ta bort ${productName} från varukorgen`"
      classes="absolute right-0"
      icon-name="x"
      @click="emit('onRemoveInsuranceItem')"
      @keydown.enter.self.prevent="emit('onRemoveInsuranceItem')"
      @keydown.space.self.prevent="emit('onRemoveInsuranceItem')"
    />
  </div>
</template>

<script lang="ts" setup>
const checkoutStore = useMyCheckoutStore();

interface Props {
  imgSrc?: string;
  productName: string;
  itemInfo: string[];
  itemInfoSecondary?: string;
  regPriceString?: string;
  priceString: string;
  bindPeriodTime?: number;
  downPayTime?: number;
  showFullPrice?: boolean;
  cartItemId: number;
  removeSpecificItem?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  imgSrc: '',
  productName: '',
  info: [],
  regPriceString: '',
  priceString: '',
  bindPeriodTime: 0,
  downPayTime: 1,
});

const emit = defineEmits(['onRemoveInsuranceItem']);

const appliedDiscounts = computed(() =>
  checkoutStore.fetchedData.cart.appliedDiscounts.filter(
    (appliedDiscounts) =>
      appliedDiscounts.ShoppingCartItemId === props.cartItemId,
  ),
);

const discountValidityInMonths = computed(
  () =>
    checkoutStore.fetchedData.cart.appliedDiscounts.filter(
      (appliedDiscounts) =>
        appliedDiscounts.ShoppingCartItemId === props.cartItemId &&
        appliedDiscounts.TholboxDiscountValidityInMonths &&
        appliedDiscounts.TholboxMonthlyDiscountAmount,
    )[0],
);
</script>

<style scoped lang="scss"></style>
